<app-document-templates-nav></app-document-templates-nav>

<div class="capitan-sub-nav-post-content pb-5">

  <div class="pt-3" *ngIf="!accountService.getMyAccount().is_organization_admin">
    <h2>You do not have permission to manage policies.</h2>
  </div>

  <div class="pt-3" *ngIf="serverError !== null">
    <h2>Server Error: {{ serverError }}</h2>
  </div>

  <ng-container *ngIf="accountService.getMyAccount().is_organization_admin && (serverError === null)">

    <div class="pt-3 pl-md-4">

      <div class="row">
        <div class="col-sm-7">
          <h2>Policies <span *ngIf="loadingDocumentPolicies" class="text-secondary">- Loading...</span></h2>
        </div>

        <div class="col-sm-5">
          <button routerLink="/document-policies/add" type="button" class="btn btn-success float-right mb-3">
            Add Policy
          </button>
        </div>
      </div>

      <div class="alert alert-success" role="alert"
           [class.alert-success]="history.state.feedback.status == 'success'"
           [class.alert-info]="history.state.feedback.status == 'info'"
           *ngIf="history && history.state && history.state.feedback">
        {{ history.state.feedback.text }}
      </div>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table">

          <thead>
          <tr>
            <th scope="col">Policy Name</th>
            <th scope="col">Appears in Following Templates</th>
            <th scope="col">Last Edited</th>
            <th></th>
          </tr>
          </thead>

          <tbody *ngIf="resultsPresent()">
          <tr *ngFor="let documentPolicy of documentPolicyList.results">
            <td>
              {{ documentPolicy.name }}
            </td>
            <td>
              <ng-container *ngIf="loadingDocumentTemplates">
                <span class="text-muted">Loading...</span>
              </ng-container>
              <ng-container *ngIf="!loadingDocumentTemplates">
                <ng-container *ngFor="let documentTemplateId of documentPolicy.containing_document_template_ids">
                  <!-- Skip retired templates: they're absent from the active-only
                       name map, so rendering them would leave a blank line (PRO-863). -->
                  <span *ngIf="documentTemplateIdToName[documentTemplateId]">
                    {{ documentTemplateIdToName[documentTemplateId] }} <br>
                  </span>
                </ng-container>
              </ng-container>
            </td>
            <td>
              {{ documentPolicy.updated_at|date:"medium" }}
            </td>
            <td class="table-button-cell">
              <a href="{{ documentPolicy.climber_app_url }}" target="_blank" class="btn btn-outline-primary btn-sm float-right">View</a>
              <a routerLink="/document-policies/{{ documentPolicy.id }}" class="btn btn-outline-primary btn-sm float-right mr-2">Edit</a>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!resultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingDocumentPolicies ? 'Loading...' : 'No document policies' }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>

  </ng-container>

</div>
